module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Cupboard-b71fc8cc1e32d94d4c6bbf0e473b2c3a.svg";